import { useEffect, useState } from "react";
import { IHeaderSetters } from "../Journal";
import { JournalViewModel } from "../../../ViewModel/JournalViewModel";
import { DailyEntryViewModel } from "../../../ViewModel";
import './HomePage.css';
import { Card, Icons } from "../SharedComponents";
import { JournalStrings } from "../SharedComponents/JournalStrings";
import { RecapEntriesViewModel } from "../../../ViewModel/RecapEntriesViewModel";
import { RecapSummaryCard } from "./RecapSummaryCard";
import { ProgressBar } from "primereact/progressbar";
import { format } from "date-fns";
import React from "react";
import { useNavigate } from "react-router";
import { IDayStatus, WeeklyProgress } from "../SharedComponents/WeeklyProgress";
import { TutorialFlyout } from "../SharedComponents/TutorialFlyout";
import { GetToday } from "../../../Services/Utilities";
import ScoreTrendChart from "../SharedComponents/GLChart";
import { FeedbackButton } from "../Feedback/Feedback";
import { IProperyChangedArgs } from "../../../Utilities";



export function HomePage({ journalViewModel, headerSetters }: { journalViewModel: JournalViewModel, headerSetters: IHeaderSetters }) {

    // const [UserProfileViewModel, setUserProfileViewModel] = useState<UserProfileViewModel | undefined>(undefined);
    const [dailyEntryViewModel, setDailyEntryViewModel] = useState<DailyEntryViewModel | undefined>(undefined);

    useEffect(() => {

        var firstName = journalViewModel.UserProfileViewModel.TypedData.firstName;

        headerSetters.clear();
        headerSetters.setHeaderTitle(`Welcome ${firstName}!`);
        headerSetters.setHeaderDate(format(GetToday(), 'M-d-yyyy'));
        headerSetters.setIsReadyToRender(true);


        // setUserProfileViewModel(model.UserProfileViewModel);
        setDailyEntryViewModel(journalViewModel.TodaysDailyEntry);

    }, [headerSetters]);

    if (!dailyEntryViewModel)
        return (<></>);


    return (
        <div className="gl-home-page">
            <TodaySection journalViewModel={journalViewModel} />
            <ProgressSection journalViewModel={journalViewModel} />
            <RecapSection />
            <TrendsSection journalViewModel={journalViewModel} />
        </div>
    );
}






////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// #region Today Section
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function TodaySection({ journalViewModel }: { journalViewModel: JournalViewModel }) {

    const [todayInfo, setTodayInfo] = React.useState(journalViewModel.TodaysDailyEntry.TodayInfo);
    const navigate = useNavigate();
    const todayEntry = journalViewModel.TodaysDailyEntry;
    const todayRoute = todayEntry.Route;


    useEffect(() => {

        const onPropertyChanged = async () => {
            let tempInfo = todayEntry.TodayInfo;
            setTodayInfo(tempInfo);
        };

        todayEntry.PropertyChanged.Subscribe(onPropertyChanged);
        onPropertyChanged();

        return () => {
            todayEntry.PropertyChanged.Unsubscribe(onPropertyChanged);
        }
    }, []);


    const CardWrapper = ({ children, shouldWrap, route }: { children: React.ReactNode, shouldWrap?: boolean, route?: string }) => {

        const theRoute = route ?? todayEntry.Route;
        if (shouldWrap)
            return (
                <Card className="gl-joyride-1" noMargin>
                    <div onClick={(e) => {
                        console.log("Navigating to: ", theRoute);
                        navigate(theRoute)
                        e.stopPropagation();
                    }}>
                        {children}
                    </div>
                </Card>
            );

        return (
            children
        );
    }

    const TodayHeader = ({ text, status }: { text: string, status: "notStarted" | "inProgress" | "complete" }) => {
        return (
            <div className="gl-today-group-header flex flex-row align-items-center">
                {status === "notStarted" && <Icons.TodayStatusNotStarted />}
                {status === "inProgress" && <Icons.TodayStatusInProgress />}
                {status === "complete" && <Icons.TodayStatusComplete />}
                <p className="gl-today-info-typography">{text}</p>
            </div>
        )
    }

    const TodayItem = ({ text, value }: { text: string, value: number }) => {
        return (
            <div className="gl-today-item flex-1" >
                <p className="gl-today-item-header gl-today-date-typography">{text}</p>
                <ProgressBar className="gl-today-item-progress" value={value} showValue={false}></ProgressBar>
            </div>
        )
    };

    const TodayGroup = ({ info, route }: {
        info: {
            headerText: string;
            status: "notStarted" | "inProgress" | "complete";
            items: {
                text: string;
                value: number;
            }[]
        },
        route?: string
    }) => {

        return (
            < div className="gl-today-group" >
                <CardWrapper shouldWrap={info.status === "inProgress"} route={route}>
                    <TodayHeader text={info.headerText} status={info.status} />
                    {
                        info.items.length > 0 && info.status === "inProgress" &&
                        <div className="gl-today-items-row flex flex-row gap-4 h-full">
                            {info.items.map((item) => (<TodayItem text={item.text} value={item.value} key={item.text} />))}
                        </div>
                    }
                </CardWrapper>
            </div >
        );
    }

    return (
        <div className="gl-home-section gl-today-section relative" >
            <TutorialFlyout steps={[
                {
                    target: '.gl-today-section',
                    title: JournalStrings.TutorialFlyout["gl-today-section"].Title,
                    content: (
                        <>
                            <p>{JournalStrings.TutorialFlyout["gl-today-section"]["Content-0"]}</p>
                            <p><strong>{JournalStrings.TutorialFlyout["gl-today-section"]["Content-1-0"]}</strong>{JournalStrings.TutorialFlyout["gl-today-section"]["Content-1-1"]}</p>
                            <p><strong>{JournalStrings.TutorialFlyout["gl-today-section"]["Content-2-0"]}</strong>{JournalStrings.TutorialFlyout["gl-today-section"]["Content-2-1"]}</p>
                            <p><strong>{JournalStrings.TutorialFlyout["gl-today-section"]["Content-3-0"]}</strong>{JournalStrings.TutorialFlyout["gl-today-section"]["Content-3-1"]}</p>

                        </>
                    ),
                    disableBeacon: true,
                    offset: 0
                }
            ]}>
                <div className="gl-home-section-title flex flex-row justify-content-between align-items-center h-full ">
                    <p className="m-0">Today</p>
                </div>
            </TutorialFlyout>
            <div onClick={() => navigate(todayRoute)}>
                {todayInfo.map((info) => (<TodayGroup info={info} key={info.headerText} route={info.route} />))}
            </div>
            <FeedbackButton viewModel={journalViewModel.FeedbackViewModel} />
        </div>
    );
}


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// #endregion Today Section
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// #region Recap Section
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


function RecapSection() {

    const [recapEntries, setRecapEntries] = useState<RecapEntriesViewModel[] | undefined>(RecapEntriesViewModel.DisplayRecaps);

    useEffect(() => {

        const getEntries = async (e: IProperyChangedArgs) => {
            if (e.property === 'Recaps') {
                var recaps = RecapEntriesViewModel.DisplayRecaps;
                setRecapEntries(recaps);
            }
        };

        RecapEntriesViewModel.PropertyChanged.Subscribe(getEntries);


        return () => {
            RecapEntriesViewModel.PropertyChanged.Unsubscribe(getEntries);
        };
    }, []);

    const showPlaceholder = !recapEntries || recapEntries.length === 0;


    return (
        <div className="gl-home-section gl-recaps-section pl-0 pr-0">
            <div className="flex flex-row justify-content-between align-items-end ml-100">

                <TutorialFlyout steps={[
                    {
                        target: '.gl-recaps-section',
                        title: JournalStrings.TutorialFlyout["gl-recaps-section"].Title,
                        content: (
                            <>
                                <p>{JournalStrings.TutorialFlyout["gl-recaps-section"]["Content-0"]}</p>
                                <p><strong>{JournalStrings.TutorialFlyout["gl-recaps-section"]["Content-1-0"]}</strong>{JournalStrings.TutorialFlyout["gl-recaps-section"]["Content-1-1"]}</p>
                                <p>{JournalStrings.TutorialFlyout["gl-recaps-section"]["Content-2-0"]}<strong>{JournalStrings.TutorialFlyout["gl-recaps-section"]["Content-2-1"]}</strong>{JournalStrings.TutorialFlyout["gl-recaps-section"]["Content-2-2"]}</p>
                            </>
                        ),
                        disableBeacon: true,
                        offset: 0
                    }

                ]}>
                    <div className="flex align-items-center">
                        <p className="gl-home-section-title m-0">Recaps</p>
                    </div>
                </TutorialFlyout>
                {
                    recapEntries?.length !== 0 && false &&
                    <div onClick={() => { }}>
                        <p className="text-xs m-0">View all</p>
                    </div>
                }
            </div>
            <div className={`${showPlaceholder ? 'overflow-x-visible' : 'overflow-x-auto'} flex flex-row`}>
                {
                    showPlaceholder
                        ?
                        //
                        // Render the placeholder if we don't have any entries yet
                        //
                        <Card
                            noMargin
                            className="gl-placeholder-card gl-recap-placeholder relative ml-100 mr-100"
                            disableClick={showPlaceholder}
                        >
                            <Icons.TransparentLeaf className="gl-recap-placeholder-watermark" />
                            <div className="gl-home-section-title">
                                <p className="mt-150 mb-150 ml-125 mr-125">{JournalStrings.Home.Placeholders.Recaps}</p>
                            </div>
                            <div className=" flex flex-row justify-content-center align-items-center mb-125">
                                <Icons.RecapPlaceholderIcons className="relative" />
                            </div>
                        </Card>
                        :
                        recapEntries.map((entry) => (
                            <RecapSummaryCard
                                entry={entry}
                                key={entry.Data!.key}
                                className="gl-home-recap-summary-card"
                            />
                        ))
                }
            </div>
        </div>
    );
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// #endregion Recap Section
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////






////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// #region Progress Section
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


/**
 * The ProgressSection component displays the user's progress in the journal.
 *  
 */
function ProgressSection({ journalViewModel }: { journalViewModel: JournalViewModel }) {

    const [weeklyRecaps, setWeeklyRecaps] = useState<RecapEntriesViewModel[]>(journalViewModel.AllWeeklyRecaps);

    useEffect(() => {
        const updateRecaps = async () => {
            setWeeklyRecaps(journalViewModel.AllWeeklyRecaps);
        }

        journalViewModel.PropertyChanged.Subscribe(updateRecaps);

        return () => {
            journalViewModel.PropertyChanged.Unsubscribe(updateRecaps);
        }
    }, []);

    const showPlaceholder = !weeklyRecaps || weeklyRecaps.length === 0;
    const cardNames = showPlaceholder ? ' gl-placeholder-card relative' : '';

    const ProgressCard = ({ entries }: { entries: IDayStatus[] }) => {

        let headerText = `${format(entries[0].date, 'MMMM d')} - ${format(entries[entries.length - 1].date, 'd, yyyy')}`;
        if (entries.filter((e) => e.date.getTime() === GetToday().getTime()).length === 1)
            headerText = 'Your progress this week:';
        return (
            <div className="gl-progress-card">
                <Card
                    noMargin
                    className={`mt-0 mb-0 w-full${cardNames}`}
                    disableClick
                >

                    <div className="gl-home-section-title gl-recap-summary-header">
                        <p className="mt-75 mb-75 ml-125 mr-125">{headerText}</p>
                    </div>
                    <div className="mb-125 ml-125 mr-125">
                        <WeeklyProgress statuses={entries} />
                    </div>
                </Card>
            </div>
        )
    }

    return (
        <div className="gl-home-section gl-progress-section">
            <div className="flex flex-row justify-content-between align-items-end">

                <TutorialFlyout steps={[
                    {
                        target: '.gl-progress-section',
                        title: JournalStrings.TutorialFlyout["gl-progress-section"].Title,
                        content: (
                            <>
                                <p>{JournalStrings.TutorialFlyout["gl-progress-section"]["Content-0"]}</p>
                                <p>{JournalStrings.TutorialFlyout["gl-progress-section"]["Content-1"]}</p>
                                <p><strong>{JournalStrings.TutorialFlyout["gl-progress-section"]["Content-2-0"]}</strong>{JournalStrings.TutorialFlyout["gl-progress-section"]["Content-2-1"]}</p>
                            </>
                        ),
                        disableBeacon: true,
                        offset: 0
                    }

                ]}>
                    <div className="flex align-items-center">
                        <p className="gl-home-section-title gl-progress-section-title mt-0 mb-0">Progress</p>
                    </div>
                </TutorialFlyout>

                {/* {
                    recapEntries?.length !== 0 &&
                    <div onClick={() => { }}>
                        <p className="text-xs m-0">View all</p>
                    </div>
                } */}
            </div>
            <div className={`${showPlaceholder ? 'overflow-x-visible' : 'overflow-x-auto'} mt-100 flex flex-row`}>
                {
                    showPlaceholder
                        ?
                        //
                        // Render the placeholder if we don't have any entries yet
                        //
                        <Card
                            noMargin
                            className={`gl-progress-placeholder mt-100 w-full${cardNames} ml-100 mr-100`}
                            disableClick
                        >
                            <>
                                <Icons.TitleIcon className="gl-placeholder-card-adorner" />
                                <div className="gl-home-section-title">
                                    <p className="mt-75 mb-150 ml-125 mr-125">{JournalStrings.Home.Placeholders.Progress}</p>
                                </div>
                                <div className="mb-125 ml-125 mr-125">

                                    <WeeklyProgress showComplete />
                                </div>
                            </>
                        </Card>
                        :
                        weeklyRecaps.map((recap) =>
                            <ProgressCard
                                key={recap.TypedData.key}
                                entries={recap.WeeklyStatus}
                            />
                        )

                }

            </div>
        </div>
    );
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// #endregion Progress Section
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////







////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// #region Trends Section
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



function TrendsSection(_props: { journalViewModel: JournalViewModel }) {

    return (
        <div className="gl-home-section gl-trends-section mb-5">
            <div className="flex flex-row justify-content-between align-items-end">

                <TutorialFlyout steps={[
                    {
                        target: '.gl-trends-section',
                        title: JournalStrings.TutorialFlyout["gl-trends-section"].Title,
                        content: (
                            <>
                                <p>{JournalStrings.TutorialFlyout["gl-trends-section"]["Content-0"]}</p>
                                <p>{JournalStrings.TutorialFlyout["gl-trends-section"]["Content-1"]}</p>
                                <p><strong>{JournalStrings.TutorialFlyout["gl-trends-section"]["Content-2-0"]}</strong>{JournalStrings.TutorialFlyout["gl-trends-section"]["Content-2-1"]}</p>
                            </>
                        ),
                        disableBeacon: true,
                        offset: 0
                    }
                ]}>
                    <div className="flex align-items-center">
                        <p className="gl-home-section-title m-0">Trends</p>
                    </div>
                </TutorialFlyout>
            </div>
            <ScoreTrendChart viewmodel={_props.journalViewModel.ScoreTrendViewModel} />
        </div>
    );
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// #endregion Trends Section
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////